import { useState } from 'react';
import { NavLink, generatePath } from 'react-router-dom';
import { PermissionEnum } from '../../../../../baseella-ui-components/src';
import Card from '../../common/card/card';
import { CofStatus, CustomerStatus } from '../../../hoc/common/types';
import CompanyOfficialListItem from './company-official-list-item';
import { CompanyOfficialTypes } from '../types';

import ROUTES from '../../../routes';

import cn from './overview.module.css';

const CompanyOfficial = ({
  isLoading,
  companyOfficial,
  customerId,
  cardsMatch,
  status,
  activePermissions,
}: CompanyOfficialTypes) => {
  const [selectedTab, setSelectedTab] = useState<'current' | 'removed'>(
    'current',
  );

  return (
    <>
      <div className={cn.companyOfficialTitle}>
        <div className={cn.companyOfficialTitleText}>Company official</div>
        {activePermissions?.includes(
          PermissionEnum.CORPORATE_CUSTOMERS_EDIT_OFFICIALS_ACTION,
        ) &&
          status !== CustomerStatus.CLOSED && (
            <NavLink
              to={generatePath(
                !cardsMatch
                  ? ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_COMPANY_OFFICIAL
                  : ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_COMPANY_OFFICIAL,
                {
                  customerId,
                },
              )}
              className={cn.companyOfficialTitleLink}
            >
              Edit
            </NavLink>
          )}
      </div>
      {!isLoading && (
        <div className={cn.companyOfficialTabs}>
          <button
            type="button"
            className={`${cn.companyOfficialTab} ${
              selectedTab === 'current' ? cn.active : ''
            }`}
            onClick={() => setSelectedTab('current')}
          >
            Current
          </button>
          <button
            type="button"
            className={`${cn.companyOfficialTab} ${
              selectedTab === 'removed' ? cn.active : ''
            }`}
            onClick={() => setSelectedTab('removed')}
          >
            Removed
          </button>
        </div>
      )}
      <Card isLoading={isLoading}>
        <div className={cn.companyOfficialContent}>
          {selectedTab === 'current' &&
            companyOfficial &&
            companyOfficial?.length > 0 &&
            companyOfficial
              .filter(
                (item) =>
                  item.status !== CofStatus.ARCHIVED &&
                  item.status !== CofStatus.REJECTED,
              )
              .map((item) => (
                <CompanyOfficialListItem key={item.id} item={item} />
              ))}
          {selectedTab === 'removed' &&
            companyOfficial &&
            companyOfficial?.length > 0 &&
            companyOfficial
              .filter(
                (item) =>
                  item.status === CofStatus.ARCHIVED ||
                  item.status === CofStatus.REJECTED,
              )
              .map((item) => (
                <CompanyOfficialListItem key={item.id} item={item} />
              ))}
        </div>
      </Card>
    </>
  );
};

export default CompanyOfficial;
